export default {
  title: 'Nuovo prezzo',
  fields: {
    product: {
      label: 'Prodotto',
    },
    is_not_personal: {
      label: 'Visibile a tutti',
    },
    is_default: {
      label: 'Predefinito',
    },
    visible_to: {
      label: 'Visibile a',
    },
  },
  buttons: {
    select_all: 'Seleziona tutto',
    save: 'Salva',
    cancel: 'Annulla',
  },
  feedback: {
    missing_info: 'Informazioni mancanti',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati fallito',
    price_got_created: 'Prezzo creato',
    price_got_updated: 'Prezzo aggiornato',
  },
};
